/*
  Where a visitor came from, kept for the lead forms. When a page is opened
  from an ad or a tagged link, its UTM tags and click ids are saved in the
  browser for 90 days; every form adds them to the request it sends to Make,
  so Salesforce gets the source of the lead even if the visitor fills the
  form days later or on another page. A newer tagged visit replaces the older
  one as a whole, so tags from two different ads never mix. A first visit
  without tags still keeps its landing page and outside referrer.

  window.aaAttribution() returns the saved values, empty strings for the rest.
*/
(function () {
  var STORE = 'aa_attribution';
  var DAYS = 90;
  var TAGS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'fbclid', 'msclkid'];
  var FIELDS = TAGS.concat(['landing_page', 'referrer']);

  function read() {
    try {
      var saved = JSON.parse(window.localStorage.getItem(STORE) || 'null');
      if (saved && saved.saved_at && Date.now() - saved.saved_at < DAYS * 864e5) return saved;
    } catch (e) {}
    return null;
  }

  function write(values) {
    values.saved_at = Date.now();
    try { window.localStorage.setItem(STORE, JSON.stringify(values)); } catch (e) {}
  }

  // A referrer from this site is only a click between pages, not a source.
  function outsideReferrer() {
    var ref = document.referrer || '';
    try { if (ref && new URL(ref).hostname === window.location.hostname) ref = ''; } catch (e) { ref = ''; }
    return ref.slice(0, 500);
  }

  var found = {};
  var tagged = false;
  try {
    var params = new URLSearchParams(window.location.search);
    TAGS.forEach(function (key) {
      var value = params.get(key);
      if (value) { found[key] = value.slice(0, 200); tagged = true; }
    });
  } catch (e) {}

  var landing = (window.location.origin + window.location.pathname).slice(0, 500);
  if (tagged) {
    found.landing_page = landing;
    found.referrer = outsideReferrer();
    write(found);
  } else if (!read()) {
    write({ landing_page: landing, referrer: outsideReferrer() });
  }

  window.aaAttribution = function () {
    var saved = read() || {};
    var out = {};
    FIELDS.forEach(function (key) { out[key] = saved[key] || ''; });
    return out;
  };
})();
